import {INPUTIRSPOS} from './m-types'


let fmcInputs = {
    state: {
        autoFlightSystem: {
            dfcsModeCp: {},
            autoThrottle: {}
        },
        dataLoader: {},
        commonDisplaySystem: {
            efisCp: {
                
            }
        },
        airPlaneSensors: {
            antiIce: {

            },
            engineBleed: {},
            airGroundLogic: {
                //0是地,1是空
                pseu: 0,
            },
            fqpu: {
                fuelL: 2.3,
                fuelR: 2.2,
                fuelC: 0.5,
            }
        },
        positionAndAirData: {
            adiru: {
                //0-3对应 off-att
                status: 0,
                lastPos:'N36°49.9 E117°10.5',
                userPos: '',
                pos1: '',
                pos2: '',
            },
            gps: {
                pos1: 'N36°49.9 E117°10.1',
                pos2: 'N36°51.0 E117°12.3',
            }
        },
        radioNavigationSystem: {
            dme: {},
            ils: {},
            vor: {}
        },
    },
    mutations: {
        
    },
    actions: {
        [INPUTIRSPOS](state, posData){
            state.positionAndAirData.userPos = userPos
        }
    },

}

  export {fmcInputs}